import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Blog } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { initialValuesBlog, validationSchemaBlog } from "./BlogCommon"
import BlogForm from "./BlogForm"
import { useCreateBlog } from "../../hooks/blog"

export default function BlogCreate() {
  const createBlog = useCreateBlog()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesBlog(), [])
  const validationSchema = useMemo(() => validationSchemaBlog(), [])

  useBreadcrumbs([{ label: "Blog", href: "/blog/blog" }, { label: "Nuovo post" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo post</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createBlog.mutateAsync(values as Blog).then((blog) => {
                navigate(`/blog/blog/${blog.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <BlogForm />
                </Container>
                <BottomFormFixed url="/blog/blog" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
